
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import "@/store/modules/forms/form13";
const form13State = namespace("Form13");

import Form13ProcessHeader from "@/components/process/Form13/components/Form13ProcessHeader.vue";
import Form13 from "@/components/process/Form13/components/pdf/Form13.vue"

import { form13StatusInfoType } from '@/types/Information/Form13';

@Component({
    components:{
        Form13ProcessHeader,
        Form13
    }
})
export default class PreviewForm13 extends Vue {

    @form13State.State
    public currentConsentOrderExtendTimeId: string;

    stepsCompleted = {} as form13StatusInfoType;
    
    dataReady = false;
    pdfReady = false;

    mounted() {
        this.dataReady = false;
        this.stepsCompleted = {
            first: true,
            second: false,
            third: false
        }
        this.dataReady = true;       
    }

    public navigateToSubmitPage() {
        this.$router.push({name: "proceed-form13" }); 
    }
}
